export const packageLabels = [
  { value: "Select", key: "" },
  { value: "Recently Booked", key: "Recently Booked" },
  { value: "Popular", key: "Popular" },
  { value: "Best Seller", key: "Best Seller" },
  { value: "New", key: "New" },
  { value: "Offer", key: "Offer" },
];

export const packageStatus = [
  { value: "Select", key: "" },
  { value: "Active", key: "active" },
  { value: "Inactive", key: "inactive" },
];

export const rating = [
  { value: "Select", key: "" },
  { value: 1, key: 1 },
  { value: 1.5, key: 1.5 },
  { value: 2, key: 2 },
  { value: 2.5, key: 2.5 },
  { value: 3, key: 3 },
  { value: 3.5, key: 3.5 },
  { value: 4, key: 4 },
  { value: 4.5, key: 4.5 },
  { value: 5, key: 5 },
];

export const propertyType = [
  { value: "Select", key: "" },
  { value: "Hotel", key: "HOTEL" },
  { value: "Houseboat", key: "HOUSEBOAT" },
];
